<template>
  <div>
    <div class="loading-overlay" v-if="isLoading">
      <div class="spinner-border text-danger" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <bs-page-title
      :titleLabel="fromParentTitle"
      :btnLabel="fromParentBtn"
      :btnClass="'btn-primary'"
    ></bs-page-title>
    <bs-msg-alert :alertClass="alertClass">
      先行リリース版です。<br />競技役員のみの設定を想定しています。<br />{{
        this.alertMessage
      }}
    </bs-msg-alert>
    <!-- {{ license_promotion_obj }} -->
    <div class="w100">
      <div class="row mb-3" v-if="false">
        <div class="col-4">
          <label for="Label" class="form-label">名称</label>
          <input
            type="text"
            class="form-control-plaintext"
            id="Label"
            placeholder="名称"
            v-model="(license_promotion_obj || {}).label"
          />
        </div>
      </div>
      <div class="mb-5"></div>
      <!-- {{ event_cd_obj.relation }} -->
      <h5>条件詳細</h5>
      <div class="row mb-3">
        <div class="col-12">
          <table class="table">
            <thead>
              <tr>
                <th style="width: 18%">名称</th>
                <th style="width: 15%">
                  <bs-select
                    :options="license_cd_list"
                    v-model="filter_param.from_license_cd"
                    :null-option="'昇格前ライセンス'"
                    :classParam="'form-select-sm'"
                  ></bs-select>
                </th>
                <th style="width: 15%">
                  <bs-select
                    :options="license_cd_list"
                    v-model="filter_param.to_license_cd"
                    :null-option="'昇格ライセンス'"
                    :classParam="'form-select-sm'"
                  ></bs-select>
                </th>
                <th style="width: 10%">
                  <bs-select
                    :options="promotion_type_list"
                    v-model="filter_param.promotion_type"
                    :null-option="'昇格区分'"
                    :classParam="'form-select-sm'"
                  ></bs-select>
                </th>
                <th style="width: 12%">
                  <bs-select
                    :options="promotion_condition_type_list"
                    v-model="filter_param.promotion_condition_type"
                    :null-option="'昇格条件種別'"
                    :classParam="'form-select-sm'"
                  ></bs-select>
                </th>
                <th style="width: 13%">条件値</th>
                <th style="width: 7%">優先度</th>
                <th style="width: 10%">-</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="condition in filter_condition" :key="condition">
                <td>
                  <input
                    type="text"
                    v-model="condition.label"
                    class="form-control form-control-sm"
                  />
                </td>
                <td>
                  <bs-select
                    :options="license_cd_list"
                    v-model="condition.from_license_cd"
                    :null-option="'昇格前ライセンス'"
                    :classParam="'form-select-sm'"
                  ></bs-select>
                </td>
                <td>
                  <bs-select
                    :options="license_cd_list"
                    v-model="condition.to_license_cd"
                    :null-option="'昇格ライセンス'"
                    :classParam="'form-select-sm'"
                  ></bs-select>
                </td>
                <td>
                  <bs-select
                    :options="promotion_type_list"
                    v-model="condition.promotion_type"
                    :null-option="'昇格区分'"
                    :classParam="'form-select-sm'"
                  ></bs-select>
                </td>
                <td>
                  <bs-select
                    :options="promotion_condition_type_list"
                    v-model="condition.condition_type"
                    :null-option="'昇格条件種別'"
                    :classParam="'form-select-sm'"
                  ></bs-select>
                </td>
                <td>
                  <input
                    type="text"
                    v-model="condition.condition_value"
                    class="form-control form-control-sm"
                  />
                </td>
                <td>
                  <input
                    type="number"
                    v-model="condition.priority"
                    class="form-control form-control-sm"
                  />
                </td>
              </tr>
            </tbody>
            <tbody>
              <tr v-for="add in add_condition" :key="add">
                <td>
                  <input
                    type="text"
                    v-model="add.label"
                    class="form-control form-control-sm"
                  />
                </td>
                <td>
                  <bs-select
                    :options="license_cd_list"
                    v-model="add.from_license_cd"
                    :null-option="'昇格前ライセンス'"
                    :classParam="'form-select-sm'"
                  ></bs-select>
                </td>
                <td>
                  <bs-select
                    :options="license_cd_list"
                    v-model="add.to_license_cd"
                    :null-option="'昇格ライセンス'"
                    :classParam="'form-select-sm'"
                  ></bs-select>
                </td>
                <td>
                  <bs-select
                    :options="promotion_type_list"
                    v-model="add.promotion_type"
                    :null-option="'昇格区分'"
                    :classParam="'form-select-sm'"
                  ></bs-select>
                </td>
                <td>
                  <bs-select
                    :options="promotion_condition_type_list"
                    v-model="add.condition_type"
                    :null-option="'昇格条件種別'"
                    :classParam="'form-select-sm'"
                  ></bs-select>
                </td>
                <td>
                  <input
                    type="text"
                    v-model="add.condition_value"
                    class="form-control form-control-sm"
                  />
                </td>
                <td>
                  <input
                    type="number"
                    v-model="add.priority"
                    class="form-control form-control-sm"
                  />
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="8">
                  <div class="text-end">
                    <button
                      @click="add_form"
                      class="btn btn-light btn-outline-secondary"
                    >
                      追加
                    </button>
                  </div>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>

      <div class="mb-5"></div>
      <div class="row mb-3">
        <div class="col-12 col-sm-4 mb-2">
          <button
            type="submit"
            @click="back"
            class="btn btn-light btn-outline-secondary"
          >
            戻る
          </button>
        </div>
        <div
          class="col-12 col-sm-4 mb-2 text-center"
          v-if="chk_relation_type_editable('/master/list')"
        >
          <button type="submit" @click="update" class="btn btn-primary">
            {{ btnLabel }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import BsPageTitle from '../../molecules/BsPageTitle.vue'
import BsMsgAlert from '../../atoms/BsMsgAlert.vue'
import BsSelect from '../../atoms/BsSelect.vue'
import config from '../../../const'

export default {
  name: 'LicensePromotionView',
  data: function () {
    return {
      targetid: this.$route.params.id,
      fromParentTitle: 'ライセンス昇降格マスタ',
      fromParentBtn: '',
      alertMessage: '',
      alertClass: 'alert-info',
      btnLabel: '',
      promotion_type_obj: [],
      promotion_condition_type_obj: [],
      license_promotion_obj: {},
      license_event_cd_obj: [],
      license_cd_obj: [],
      filter_param: {
        promotion_type: '',
        condition_type: '',
        from_license_cd: '',
        to_license_cd: ''
      },
      add_condition: [],
      add_condition_frm: {
        id: 0,
        stat: 1,
        promotion_id: this.$route.params.id,
        promotion_type: '',
        condition_type: '',
        from_license_cd: '',
        to_license_cd: '',
        priority: '',
        condition_value: '',
        label: ''
      },
      isLoading: false
    }
  },
  components: {
    BsPageTitle,
    BsSelect,
    BsMsgAlert
    // BsButton,
    // BsCheckBox,
  },
  methods: {
    async add_form() {
      const tmps = [...this.add_condition]
      const frm = { ...this.add_condition_frm }
      const num = (this.license_promotion_obj || {}).conditions
        ? (this.license_promotion_obj || {}).conditions.length
        : 0
      frm.priority = num + tmps.length
      tmps.push(frm)
      this.add_condition = tmps
    },
    async attach_license(license_id) {
      console.log('attach_license license_id', license_id)
      const relation = [...this.event_cd_obj.relation]
      console.log('attach_license relation', relation)
      if (relation.find(obj => obj.license_cd == license_id)) {
        const index = relation.findIndex(obj => obj.license_cd == license_id)
        relation.splice(index, 1)
      } else {
        const tmp = { ...this.relation_form_obj }
        tmp.license_cd = license_id
        relation.push(tmp)
      }
      console.log('attach_license relation2', relation)
      this.event_cd_obj.relation = relation
    },
    async loadLicenseCdList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(config.BASE_API_URL + '/license_cd/lists', params)
        .then(async response => {
          console.log('loadLicenseCdList response', response)
          this.license_cd_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.license_cd_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadLicenseEventCdList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(
        config.BASE_API_URL + '/license_event_cd/lists',
        params
      )
        .then(async response => {
          console.log('loadLicenseEventCdList response', response)
          this.license_event_cd_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.license_event_cd_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadLicensePromotionObj() {
      const params = {}
      params['id'] = this.targetid
      await this.basicPosts_S(
        config.BASE_API_URL + '/license_promotion/lists',
        params
      )
        .then(async response => {
          console.log('loadLicensePromotionObj', response)
          this.license_promotion_obj =
            response.data && response.data.body && response.data.body[0]
              ? response.data.body[0]
              : {}
        })
        .catch(async err => {
          console.log(err)
          this.license_promotion_obj = {}
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async update() {
      this.isLoading = true
      try {
        await new Promise(resolve => setTimeout(resolve, 500))
        // console.log('component methods', this.license_promotion_obj)
        const params = { ...this.license_promotion_obj }
        if (!Array.isArray(params.conditions)) {
          params.conditions = []
        }
        if (
          Array.isArray(this.add_condition) &&
          this.add_condition.length > 0
        ) {
          this.add_condition.map(condition => {
            params.conditions.push(condition)
          })
        }

        return this.$store
          .dispatch('updateBasic', {
            data: params,
            target: 'license_promotion'
          })
          .then(() => {
            this.alertMessage = this.btnLabel + 'しました'
            this.alertClass = 'alert-success'
            this.add_condition = []
          })
          .catch(err => {
            Promise.reject(err)
            this.alertMessage = this.btnLabel + 'できませんでした'
            this.alertClass = 'alert-danger'
          })
          .finally(async () => {
            await this.loadLicensePromotionObj()
          })
      } catch (err) {
        console.log(err)
      } finally {
        this.isLoading = false
      }
    },
    back() {
      this.$router.go(-1)
    }
  },
  computed: {
    promotion_condition_type_list: function () {
      return this.promotion_condition_type_obj
    },
    promotion_type_list: function () {
      return this.promotion_type_obj
    },
    ...mapState({}),
    filter_condition: function () {
      return Array.isArray(this.license_promotion_obj?.conditions)
        ? this.license_promotion_obj?.conditions.filter(condition => {
            let chk = true
            if (typeof this.filter_param === 'object') {
              Object.keys(this.filter_param).map(param_key => {
                if (
                  this.filter_param[param_key] != '' &&
                  condition[param_key] != this.filter_param[param_key]
                ) {
                  chk = false
                }
              })
            }
            return chk
          })
        : []
    },
    attach_license_chk: function () {
      const relation = this.event_cd_obj.relation
      return function (license_cd) {
        if (
          typeof relation === 'object' &&
          relation.find(cd => cd.license_cd == license_cd)
        ) {
          return true
        }
        return false
      }
    },
    attach_license_class: function () {
      const chk_comp = this.attach_license_chk
      return function (license_cd) {
        if (chk_comp(license_cd)) {
          return 'btn btn-primary btn-sm'
        }
        return 'btn btn-light btn-outline-secondary btn-sm'
      }
    },
    license_cd_list: function () {
      const license_cd = this.license_cd_obj.filter(
        license => license.license_category == 4
      )
      return license_cd.sort((a, b) => {
        if (parseInt(a.sort) < parseInt(b.sort)) {
          return -1
        } else {
          return 1
        }
      })
    },
    license_cd_filter_license_event_cd: function () {
      const license_cd = this.license_cd_list
      return function (license_event_cd) {
        return license_cd.filter(lc => {
          if (lc.license_event_cd == license_event_cd) {
            return true
          }
          return false
        })
      }
    },
    license_event_cd_list: function () {
      const license_evnet_cd = this.license_event_cd_obj
      return license_evnet_cd.sort((a, b) => {
        if (parseInt(a.sort) < parseInt(b.sort)) {
          return -1
        } else {
          return 1
        }
      })
    }
  },

  async created() {
    await this.loadLicenseEventCdList()
    await this.loadLicenseCdList()
    this.promotion_condition_type_obj = await this.getConfigAPI(
      'promotion_condition_type'
    )
    this.promotion_type_obj = await this.getConfigAPI('promotion_type')
    if (Number.isNaN(this.targetid)) {
      this.targetid = 1
    } else if (this.targetid != 'add' && !Number.isNaN(this.targetid)) {
      this.loadLicensePromotionObj()
      this.btnLabel = '更新'
    } else {
      this.license_promotion_obj = {
        id: 0,
        label: '',
        term_start_date: '',
        term_end_date: '',
        conditions: []
      }
      this.btnLabel = '登録'
    }
    this.alertMessage = this.btnLabel + 'できます'
  },
  mounted: function () {
    this.fromParentTitle = '昇降格条件マスタ'
    // console.log('tags_list', this.tags_list);
  },
  props: {}
}
</script>
